module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default"), _vm._v(" "), _c('animation', {
    attrs: {
      "fn": _vm.animate
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-049af58e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/physics/MovementSystem.vue
// module id = 153
// module chunks = 1